module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.logs) ? _c('div', {
    staticClass: "component-reservation-controller"
  }, [_c('statistics-card4', [(_vm.bookedTimes) ? _c('dl', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('dt', [_vm._v("Start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.final_start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Booked Start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Minimum booked start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.minimum_booked_start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Actual Start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.actual_start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : _c('dl', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('dt', [_vm._v("Booked Start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), (_vm.bookedTimes) ? _c('dl', {
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('dt', [_vm._v("End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.final_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Booked End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.booked_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Maximum booked end:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.maximum_booked_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Actual End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.actual_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : _c('dl', {
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('dt', [_vm._v("Booked End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), (_vm.bookedTimes) ? _c('dl', {
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('dt', [_vm._v("Initial duration:")]), _c('dd', [_vm._v(_vm._s(_vm.bookedTimes.human_total_booked))]), _c('dt', [_vm._v("Total duration:")]), _c('dd', [_vm._v(_vm._s(_vm.bookedTimes.human_total_booked_final))]), _c('dt', [_vm._v("Billable End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.billable_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Billing status:")]), _c('dd', [_vm._v(_vm._s(_vm.item.billing_status))]), (_vm.item.billing_status === 'UNCHARGEABLE') ? _c('dt', [_vm._v("Cancelled: " + _vm._s(_vm.item.canceled))]) : _vm._e(), (_vm.item.memo !== null) ? [_c('dt', [_vm._v("Memo")]), _c('dd', [_vm._v(_vm._s(_vm.item.memo))])] : _vm._e()], 2) : _vm._e(), _c('div', {
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('dl', [_c('dt', [_vm._v("Total driven distance:")]), _c('dd', [_vm._v(_vm._s(_vm.item.distance) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])]), _c('hr'), _c('ReservationFlag', {
    attrs: {
      "reservation": _vm.item
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-6 small-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('driver', {
    attrs: {
      "type": 'driver-card',
      "item": _vm.item.driver
    }
  })], 1), _c('vehicle', {
    attrs: {
      "type": 'compact-card',
      "item": _vm.vehicle
    }
  }, [_c('vehicle-additional-status', {
    attrs: {
      "item": _vm.vehicle
    }
  }), _c('h2', [_vm._v(_vm._s(_vm.item.booking_mode))])], 1), _c('tab-headers', {
    attrs: {
      "tabs": _vm.tabs,
      "id": 'reservation-detail',
      "activeIndex": 0
    }
  }, [_c('tab-content', {
    attrs: {
      "headerName": 'Billing & Costs',
      "active": true
    }
  }, [_c('div', {
    staticClass: "row columns"
  }, [(_vm.item.reservation_rate) ? [_c('h4', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("RR" + _vm._s(_vm.item.reservation_rate.id) + " " + _vm._s(_vm.item.reservation_rate.name))])]), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "field-cost-per-time"
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Cost per Time"), (Array.isArray(_vm.item.reservation_rate.config.time_config)) ? _c('div', [_c('h3', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.reservation_rate.time_rate.time_cost)) + " / " + _vm._s(_vm.parseMinutes(_vm.item.reservation_rate.time_rate.time_cost_cycle)))])]), _vm._l((_vm.timeConfig), function(time) {
    return _c('div', [_c('small', [_vm._v(_vm._s(time))])])
  })], 2) : _c('div', [_c('h3', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.reservation_rate.time_rate.time_cost)) + " / " + _vm._s(_vm.parseMinutes(_vm.item.reservation_rate.time_rate.time_cost_cycle)))])]), _c('small', [_vm._v(_vm._s(_vm.item.reservation_rate.time_rate.name))])])])])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "field-cost-per-distance"
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Cost Per distance"), _c('h3', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v(_vm._s(_vm.distanceConfig[0]))])]), _vm._l((_vm.distanceConfig), function(distance) {
    return _c('div', [_c('small', [_vm._v(_vm._s(distance))])])
  })], 2)])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "field-other-costs"
  }, [_vm._v("Other costs"), _c('div', {
    staticClass: "field-label"
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.getOtherCosts()))])])])])])])] : _vm._e(), _c('accordion', {
    attrs: {
      "titles": _vm.accordionData,
      "multiExpand": "true"
    }
  }, [_c('div', {
    attrs: {
      "slot": "Cost breakdown"
    },
    slot: "Cost breakdown"
  }, [_c('table', [_c('thead', _vm._l((['Id', 'Description', 'Amount']), function(head) {
    return _c('th', [_vm._v(_vm._s(head))])
  }), 0), _c('tbody', [(_vm.debugInfo.overhead) ? _c('tr', [(_vm.debugInfo.overhead) ? _c('td', [_vm._v(_vm._s(_vm.debugInfo.overhead.id))]) : _vm._e(), (_vm.debugInfo.overhead) ? _c('td', [_vm._v("Reservation overhead")]) : _vm._e(), (_vm.debugInfo.overhead) ? _c('td', [_vm._v(_vm._s(_vm.getOverHeadCost()))]) : _vm._e()]) : _vm._e(), (_vm.debugInfo.overtime) ? _c('tr', [(_vm.debugInfo.overtime) ? _c('td', [_vm._v(_vm._s(_vm.debugInfo.overtime.id))]) : _vm._e(), (_vm.debugInfo.overtime) ? _c('td', [_vm._v("Reservation overtime")]) : _vm._e(), (_vm.debugInfo.overtime) ? _c('td', [_vm._v(_vm._s(_vm.getOverTimeCost()))]) : _vm._e()]) : _vm._e(), (_vm.debugInfo.calculated_cost) ? _c('tr', [(_vm.debugInfo.calculated_cost) ? _c('td', [_vm._v(_vm._s(_vm.debugInfo.calculated_cost.id))]) : _vm._e(), (_vm.debugInfo.calculated_cost) ? _c('td', [_vm._v("Reservation R" + _vm._s(_vm.item.number))]) : _vm._e(), (_vm.debugInfo.calculated_cost) ? _c('td', [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.debugInfo.calculated_cost.total_cost))]) : _vm._e()]) : _vm._e()])])]), _c('div', {
    attrs: {
      "slot": "Applied Rates & Overrides"
    },
    slot: "Applied Rates & Overrides"
  }, [(_vm.debugInfo) ? _c('applied-rates', {
    attrs: {
      "item": _vm.getAppliedRates()
    }
  }) : _vm._e()], 1), _c('div', {
    attrs: {
      "slot": "Deposits"
    },
    slot: "Deposits"
  }, [_c('table', [_c('thead', _vm._l((['Id', 'Description', 'Status', 'Amount', 'Date']), function(head) {
    return _c('th', [_vm._v(_vm._s(head))])
  }), 0), _vm._l((_vm.deposits), function(deposit) {
    return _c('tr', {
      staticClass: "deposits"
    }, [_c('td', [_vm._v(_vm._s(deposit.id))]), _c('td', [_c('span', [_vm._v(_vm._s(deposit.reason))])]), _c('td', [_vm._v(_vm._s(deposit.status))]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency(deposit.amount)))]), _c('td', [_vm._v(" " + _vm._s(_vm.$dateFormat(deposit.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])])
  })], 2)]), _c('div', {
    attrs: {
      "slot": "Preauths"
    },
    slot: "Preauths"
  }, [_c('PreauthList', {
    attrs: {
      "reservation": _vm.item
    }
  })], 1)]), _c('hr'), (_vm.item.cost) ? _c('div', [_vm._v("Total"), _c('span', {
    staticClass: "float-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.item.cost))]), _c('div', {
    staticClass: "help-text"
  }, [_vm._v("vat included")])])]) : _vm._e()], 2)]), _c('tab-content', {
    attrs: {
      "headerName": 'Trips Data'
    }
  }, [_c('ul', {
    directives: [{
      name: "f-accordion",
      rawName: "v-f-accordion"
    }],
    staticClass: "accordion",
    attrs: {
      "data-accordion": "",
      "data-allow-all-closed": "true"
    }
  }, _vm._l((_vm.item.trips), function(trip) {
    return _c('li', {
      staticClass: "accordion-item",
      attrs: {
        "data-accordion-item": ""
      }
    }, [_c('a', {
      staticClass: "accordion-title",
      attrs: {
        "href": "#"
      }
    }, [_vm._v("Trip " + _vm._s(trip.id))]), _c('div', {
      staticClass: "accordion-content",
      attrs: {
        "data-tab-content": ""
      }
    }, [_c('table', [_c('thead', _vm._l((['Id', 'Start', 'End', 'Distance', 'Speed']), function(head) {
      return _c('th', [_vm._v(_vm._s(head))])
    }), 0), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(trip.id))]), _c('td', [_vm._v(_vm._s(_vm.$dateFormat(trip.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('td', [_vm._v(_vm._s(_vm.$dateFormat(trip.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('td', [_vm._v(_vm._s(trip.distance) + " " + _vm._s(_vm.configuration.locale.locale_distance_unit.value))]), _c('td', [_vm._v(_vm._s(trip.speed) + " " + _vm._s(_vm.configuration.locale.locale_distance_unit.value) + "/h")])])])])])])
  }), 0)]), _c('tab-content', {
    attrs: {
      "headerName": "Notes"
    }
  }, [_c('ReservationNotes')], 1), _c('tab-content', {
    attrs: {
      "headerName": 'Reports'
    }
  }, [_c('div', {
    staticClass: "component-tabbed-vehicle-costs"
  }, [(!_vm.item.reportings.length) ? [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("nothing to show")])] : _vm._l((_vm.item.reportings), function(reporting) {
    return _c('reporting', {
      attrs: {
        "item": reporting,
        "type": "reservation"
      }
    })
  })], 2)]), (_vm.item.booking_mode === 'STR') ? _c('tab-content', {
    attrs: {
      "headerName": "STR Detail"
    }
  }, [(_vm.item.segment_rate != null) ? _c('div', {
    staticClass: "row columns"
  }, [_c('accordion', {
    attrs: {
      "titles": _vm.segmentData,
      "multiExpand": "true"
    }
  }, [_c('div', {
    attrs: {
      "slot": "Segment"
    },
    slot: "Segment"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "field-segment-id"
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("id"), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.item.segment_rate.segment.id))])])])])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "field-segment-name"
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Name"), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.item.segment_rate.segment.name))])])])])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "field-segment-description"
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Description"), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.item.segment_rate.segment.description))])])])])])])]), _c('div', {
    attrs: {
      "slot": "Rental agreement"
    },
    slot: "Rental agreement"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.segment_rate.extended_description)
    }
  })])])], 1) : _c('div', {
    staticClass: "row columns"
  }, [_c('h2', {
    staticClass: "no-result-message text-center"
  }, [_vm._v("Nothing to show here yet :(")])])]) : _vm._e(), _c('tab-content', {
    attrs: {
      "headerName": "Charging sessions"
    }
  }, [_c('ChargingSessionsList', {
    attrs: {
      "reservation": _vm.item
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('BackofficeReservation', {
    attrs: {
      "item": _vm.item,
      "type": "start-end-position"
    }
  })], 1)]), (_vm.$acl('route-reservation')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [(_vm.item) ? _c('ReservationRoute', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)]) : _vm._e(), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v("Reservation Status")]), _c('h2', [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v("Commercial Status")]), _c('h2', [_vm._v(_vm._s(_vm.item.billing_status))])])]), _c('reservation-log-time-line', {
    attrs: {
      "items": _vm.logs
    }
  })], 1)])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41678d97!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Reservation.vue
// module id = 2433
// module chunks = 1